const config = {
    collection: {
        listLayout: 'CollectionWriteDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getCollection',
        listApiParamSet: {
            ip: 1,
            // sp: 5,
            // page: 1,
        },
        keyName: 'no',
        pageRow: 10,
        fileInfo: [
            {
                fileName: 'background', fileType: 'collectionBack',
            },
            {
                fileName: 'thumbnail', fileType: 'collectionThumb',
            },
        ],
        deleteFunc: 'deleteCollection',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteKeyName: 'c_idx',

        writeFunc: 'updateCollection',
        writeApiParamSet: {
            c_idx: '',
            c_title: '',
        },
        parsingData: {
            title: '',
        },
        writeSuccessType: 1,
        writeFailTypes: {},
    },
}
import util from "@/mixins/util";

export default {
    methods: {
        returnCollectionConfig(type) {
            return config[type];
        },

    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        al: {
            type: 'between',
            classname: 'filterDate'
        },
        out: {
            type: 'between',
            classname: 'filterOutDate'
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        bid: {
            type: 'query',
            classname: 'filterStatus',
        },
        bl: {
            type: 'match',
            classname: 'filterStatus',
        },
        cmty:{
            type: 'terms',
            classname: 'filterType',
        }

    }
}
